import React from 'react';
import { Typography } from '@one-thd/sui-atomic-components';
import { useViewChargedDetailsContext } from '../../../hooks/useContexts';
import { IViewChargeHistoryResponse } from '../../../models/responses/oms';

export const ViewChargedSimplifiedTotals: React.FC = () => {
  const { chargeHistoryData } = useViewChargedDetailsContext();

  // Map of field keys to display labels and value formatters if needed
  const fieldMap: Array<{
    key: keyof IViewChargeHistoryResponse;
    label: string;
  }> = [
    { key: 'originalOrderTotal', label: 'Original Order Total' },
    { key: 'refundTotal', label: 'Return Total' },
    { key: 'adjustedOrderTotal', label: 'Adjusted Order Total' },
  ];

  const chargeDetails = chargeHistoryData
    ? fieldMap
        .filter(
          ({ key }) =>
            chargeHistoryData[key] !== undefined &&
            chargeHistoryData[key] !== null &&
            chargeHistoryData[key] !== '',
        )
        .map(({ key, label }) => ({
          key: label,
          value: chargeHistoryData[key] as string,
        }))
    : [];

  return (
    <div className="sui-flex sui-flex-col sui-w-full sui-p-4">
      {chargeDetails.map(({ key, value }) => (
        <div
          key={key}
          className="sui-w-full sui-flex sui-justify-between sui-pb-2"
        >
          <Typography variant="body-lg" weight="bold">
            {key}
          </Typography>
          <Typography variant="body-lg" weight="bold">
            {value}
          </Typography>
        </div>
      ))}
    </div>
  );
};
